import TopTextImage from './topTextImage'

export default TopTextImage